import {getTenantId} from './utils';

export const API_URL = process.env.REACT_APP_API_URL || "https://store-api-dev.repox.io";
export const HOME_PAGE = getTenantId();

